import { WithID } from "@converge-collective/common/models/Base";
import { Chat } from "@converge-collective/common/models/Chat";
import {
  firestoreCollectionWithRefs,
  shallowTSToDates,
} from "@converge-collective/common/util";
import CloseIcon from "@mui/icons-material/Close";
import { Grid, IconButton, Stack, SwipeableDrawer } from "@mui/material";
import React from "react";
import { useFirestore, useFirestoreCollection, useUser } from "reactfire";
import { useChatStateWithHash, useGlobalState } from "~/lib/chat";
import ChatList from "./ChatList";
import ChatMessages from "./ChatMessages";
import { clearHash } from "~/lib/url";
import { orderBy } from "lodash";

/**
 * Mounted globally in Layout
 */
export default function ChatPanel(): React.ReactElement {
  const { data: user } = useUser();
  const [chatOpen] = useGlobalState("chatOpen");
  const [selectedChatId] = useGlobalState("selectedChatId");
  const firestore = useFirestore();

  // wire up the global state with url hash
  useChatStateWithHash();

  console.log("ChatPanel", { chatOpen, uid: user?.uid, user, selectedChatId });

  const { data: chatData } = useFirestoreCollection<WithID<Chat>>(
    user
      ? firestore
          .collection("chats")
          .where("memberUids", "array-contains", user.uid)
          // .orderBy("lastActivityAt", "desc")
          .limit(10)
      : firestore.collection("noop"),
    {
      idField: "id",
    }
  );
  const chats = orderBy(
    firestoreCollectionWithRefs<WithID<Chat>>(chatData),
    (c) => c.lastActivityAt,
    "desc"
  );
  console.log("ChatPanel", { chatData, chats });

  const selectedChatData = chats?.find((c) => c.id === selectedChatId);

  const handleClose = () => {
    // close the chat by clearing the hash
    clearHash();
  };
  const handleOpen = () => {
    // do nothing - state is controlled via url hash
    // setChatOpen(true);
  };

  // TODO - consider disabling persistent chat in mobile (should be temporary
  // instead)
  return (
    <>
      {chatOpen && (
        <SwipeableDrawer
          hideBackdrop
          variant="persistent"
          sx={{ mt: 4 }}
          PaperProps={{
            sx: {
              minWidth: { md: 700, sm: "100%" },
              maxWidth: 700,
              boxShadow: 5,
              p: 0,
              borderRadius: 3,
              mt: { md: 6 },
              mr: { md: 6 },
            },
          }}
          ModalProps={{ sx: { inset: "auto" } }}
          anchor="right"
          open={chatOpen}
          onClose={handleClose}
          onOpen={handleOpen}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              handleClose();
            }
          }}
        >
          <Grid
            sx={{ height: "100%", overflow: "hidden" }}
            container
            spacing={0}
          >
            <Grid
              sx={{
                overflowX: "hidden",
                overflowY: "scroll",
                height: "calc(100% - 40px)",
                ml: "0",
                pl: "0px !important",
                pt: "4px !important",
              }}
              item
              xs={5}
            >
              {chats && (
                <ChatList
                  selectedId={selectedChatId || selectedChatId}
                  chats={chats.map(shallowTSToDates)}
                />
              )}
            </Grid>
            <Grid
              sx={{
                borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
                height: "100%",
              }}
              item
              xs={7}
            >
              <Stack
                sx={{ p: 0.1, borderBottom: "1px solid rgba(0, 0, 0, 0.08)" }}
                direction="row"
                justifyContent="flex-end"
              >
                <IconButton onClick={handleClose} aria-label="close">
                  <CloseIcon color="primary" />
                </IconButton>
              </Stack>
              {selectedChatData && <ChatMessages chat={selectedChatData} />}
            </Grid>
          </Grid>
        </SwipeableDrawer>
      )}
    </>
  );
}
